import { PreOrderWithTransfersResponse } from '@interfaces'
import { api } from '@utils/api/api'

export interface AutoTransferWalletOrder {
  preOrderId: string
}

export interface AutoTransferWalletPreOrder {
  walletTransferPreOrdersId: string[]
}

export async function getAutoWalletTransferOrder(
  id: AutoTransferWalletOrder,
): Promise<PreOrderWithTransfersResponse> {
  return api.post(
    '/api/v1/mobile/wallets/transfers/pre-order/automatic-path',
    id,
  )
}

export async function getAutoWalletTransferPreOrder(
  walletTransferPreOrdersId: AutoTransferWalletPreOrder,
): Promise<PreOrderWithTransfersResponse> {
  return api.post(
    '/api/v1/mobile/wallets/transfers/orders',
    walletTransferPreOrdersId,
  )
}
